export default "__VITE_ASSET__zgfVb2A3__"